import StateProvider from '../StateProvider';
import withHashState from './withHashState';

export default withHashState(StateProvider);
